import { render } from "./PageNotFound.vue?vue&type=template&id=e4ab95a2"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\dividenduitkering\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__